import { supabase } from "@/integrations/supabase/client";

export interface Industry {
  id: string;
  name: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  org_id?: string | null;
  created_by?: string | null;
}

export interface CreateIndustryData {
  name: string;
}

export interface UpdateIndustryData extends Partial<CreateIndustryData> {
  id: string;
}

export const industryService = {
  // Get all active industries for the current organization
  getIndustries: async (): Promise<Industry[]> => {
    const { data, error } = await supabase
      .from('industries')
      .select('*')
      .eq('is_active', true)
      .order('name', { ascending: true });
    
    if (error) throw error;
    return data || [];
  },

  // Create new industry
  createIndustry: async (industryData: CreateIndustryData): Promise<Industry> => {
    const { data, error } = await supabase
      .from('industries')
      .insert([industryData])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  // Update industry
  updateIndustry: async ({ id, ...updateData }: UpdateIndustryData): Promise<Industry> => {
    const { data, error } = await supabase
      .from('industries')
      .update(updateData)
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  // Delete industry (soft delete by setting is_active to false)
  deleteIndustry: async (id: string): Promise<void> => {
    const { error } = await supabase
      .from('industries')
      .update({ is_active: false })
      .eq('id', id);
    
    if (error) throw error;
  }
};